export enum SectionFilter {
  ALL = 'ALL',
  CONTRACT_TERMS = 'CONTRACT_TERMS',
  UM = 'UM',
  MARKET_SHARE = 'MARKET_SHARE',
  PRICE_PROTECTION = 'PRICE_PROTECTION',
  DISMISSED = 'DISMISSED'
}
